import WorkspaceSectionLayout from '../../components/WorkspaceSectionLayout';
import { reportsSubtabs } from '../../navigation';

const ReportsLayout = () => (
  <WorkspaceSectionLayout
    eyebrow="Reports"
    title="Performance"
    description="Money collected from your booking link and till, and whether online charges have been paid out."
    ariaLabel="Reports sections"
    tabs={reportsSubtabs}
  />
);

export default ReportsLayout;
